// fetch() vers notre serveur, authentifié par le jeton EPFL. Un 401 veut dire
// que le serveur refuse un jeton qui nous semblait valide (expiré entre-temps,
// session Entra renouvelée ailleurs, horloges décalées) : on en obtient un neuf
// (renouvellement silencieux, comme un « déco-reco ») et on réessaie une fois.
// Si le serveur le refuse encore, c'est une vraie session morte : on lève
// SessionExpiredError, que reportError() traduit en invitation à se reconnecter
// au lieu du brut « Serveur 401: Invalid credentials ».
//
// Le corps est renvoyé tel quel au second essai : réservé aux corps
// rejouables (chaîne, FormData, Blob), jamais à un ReadableStream.

import { getAuthToken, renewAuthToken, SessionExpiredError } from "./auth";

export async function authFetch(url: string, init: RequestInit = {}): Promise<Response> {
  const call = (token: string) => {
    const headers = new Headers(init.headers);
    headers.set("Authorization", `Bearer ${token}`);
    return fetch(url, { ...init, headers });
  };
  const res = await call(await getAuthToken());
  if (res.status !== 401) return res;
  const fresh = await renewAuthToken();
  if (!fresh) throw new SessionExpiredError();
  const retry = await call(fresh);
  if (retry.status === 401) throw new SessionExpiredError();
  return retry;
}
